<template>
    <Table
        :disabled="disabled"
        :isBorder="true"
    >
        <template #thead>
            <tr class="hidden pad:table-row">
                <th
                    v-if="!disabled"
                    class="w-3"
                />
                <th class="lg:w-[10.5rem]">
                    保單號碼
                </th>
                <th class="w-[20%]">
                    主約險種
                </th>
                <th class="w-28">
                    被保險人
                </th>
                <th class="w-36">
                    目前繳費方式
                </th>
                <th class="w-24">
                    幣別
                </th>
                <th>
                    備註
                </th>
                <th v-if="disabled" />
            </tr>
        </template>
        <template #tbody>
            <template
                v-for="item in data"
                :key="item.fullPolicyNo"
            >
                <tr @click="!disabled?checkRow(item.policyNoSeqSrceFromIdDup):''">
                    <td
                        v-if="!disabled"
                        class="text-center pl-4"
                    >
                        <Radio
                            v-model:checkedValue="checked"
                            :value="item.policyNoSeqSrceFromIdDup"
                            name="policy1"
                            :disabled="disabled"
                        />
                    </td>
                    <td>
                        {{ item.fullPolicyNo }}
                    </td>
                    <td class="break-all">
                        {{ item.itemName }}
                    </td>
                    <td class="break-all">
                        {{ item.name }}
                    </td>
                    <td>
                        {{ item.payKindText }}
                    </td>
                    <td>
                        {{ item.currencyText }}
                    </td>
                    <td class="text-sm sm:text-base">
                        <ul
                            v-if="item.memoList.length===2"
                            class="list-disc list-inside"
                        >
                            <li>{{ item.memoList[0] }}</li>
                            <li>{{ item.memoList[1] }}</li>
                        </ul>
                        <p v-else>
                            {{ item.memoList[0] }}
                        </p>
                    </td>
                    <td
                        v-if="disabled"
                        class="p-0 w-[5.25rem]"
                    >
                        <div
                            v-if="item.memo"
                            class="bg-gray-400 text-sm text-white p-1.5"
                        >
                            {{ item.memo }}
                        </div>
                    </td>
                </tr>
            </template>
        </template>
    </Table>
</template>

<script>
import { toRef } from 'vue';
import Table from '@/components/table/TableBase.vue';
import Radio from '@/components/radios/Radio.vue';

export default {
    components: {
        Table,
        Radio,
    },
    props: {
        checkedRadio: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Array,
            default: () => []
        }
    },
    emits: ['update:checkedRadio'],
    setup(props, { emit }) {
        const checked = toRef(props, 'checkedRadio');
        const checkRow = (itemNo) => {
            emit('update:checkedRadio', itemNo);
        };
        return {
            checkRow,
            checked
        };
    }
};
</script>
